/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType, HttpClient, RequestParams } from './http-client'

export class CorrelationSchemeOptionsClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
 * No description
 * 
 * @tags CorrelationSchemeOptions
 * @summary Сохранить упорядоченный список выбранных скважин. 
(Если список пуст, метод удалит его в БД).
 * @request POST:/project/{projectId}/CorrelationScheme/{correlationSchemeId}
 * @secure
 */
  correlationSchemeOptionsSetWells = (
    projectId: string,
    correlationSchemeId: string,
    data: string[],
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/project/${projectId}/CorrelationScheme/${correlationSchemeId}`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    }) /**
   * No description
   *
   * @tags CorrelationSchemeOptions
   * @summary Получить упорядоченный список выбранных скважин или пустой, если их нет в БД.
   * @request GET:/project/{projectId}/CorrelationScheme/{correlationSchemeId}
   * @secure
   */
  correlationSchemeOptionsGetWellIds = (
    projectId: string,
    correlationSchemeId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<string[], any>({
      path: `/project/${projectId}/CorrelationScheme/${correlationSchemeId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags CorrelationSchemeOptions
   * @summary Удалить список выбранных скважин.
   * @request POST:/project/{projectId}/CorrelationScheme/{correlationSchemeId}/removeAllWells
   * @secure
   */
  correlationSchemeOptionsRemoveWells = (
    projectId: string,
    correlationSchemeId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/project/${projectId}/CorrelationScheme/${correlationSchemeId}/removeAllWells`,
      method: 'POST',
      secure: true,
      ...params,
    })
}
